import { List } from 'immutable';
import BlockTypes from '../../../types/BlockTypes';
export default function getTableCells(editor, tableId) {
  var table = editor.value.document.nodes.find(function (node) {
    return node.type === BlockTypes.TABLE && node.getIn(['nodes', 0, 'data', 'tableId']) === tableId;
  });
  return table ? table.nodes : new List();
}